/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserRead } from './UserRead';
import {
    UserReadFromJSON,
    UserReadFromJSONTyped,
    UserReadToJSON,
    UserReadToJSONTyped,
} from './UserRead';

/**
 * 
 * @export
 * @interface OrganizationRead
 */
export interface OrganizationRead {
    /**
     * 
     * @type {string}
     * @memberof OrganizationRead
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRead
     */
    id: string;
    /**
     * 
     * @type {UserRead}
     * @memberof OrganizationRead
     */
    owner?: UserRead | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationRead
     */
    max_users?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRead
     */
    license_key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRead
     */
    license_type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationRead
     */
    license_is_active?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationRead
     */
    license_valid_until?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationRead
     */
    is_active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationRead
     */
    member_count?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationRead
     */
    has_superadmin?: boolean | null;
}

/**
 * Check if a given object implements the OrganizationRead interface.
 */
export function instanceOfOrganizationRead(value: object): value is OrganizationRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OrganizationReadFromJSON(json: any): OrganizationRead {
    return OrganizationReadFromJSONTyped(json, false);
}

export function OrganizationReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'owner': json['owner'] == null ? undefined : UserReadFromJSON(json['owner']),
        'max_users': json['max_users'] == null ? undefined : json['max_users'],
        'license_key': json['license_key'] == null ? undefined : json['license_key'],
        'license_type': json['license_type'] == null ? undefined : json['license_type'],
        'license_is_active': json['license_is_active'] == null ? undefined : json['license_is_active'],
        'license_valid_until': json['license_valid_until'] == null ? undefined : (new Date(json['license_valid_until'])),
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'member_count': json['member_count'] == null ? undefined : json['member_count'],
        'has_superadmin': json['has_superadmin'] == null ? undefined : json['has_superadmin'],
    };
}

export function OrganizationReadToJSON(json: any): OrganizationRead {
    return OrganizationReadToJSONTyped(json, false);
}

export function OrganizationReadToJSONTyped(value?: OrganizationRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
        'owner': UserReadToJSON(value['owner']),
        'max_users': value['max_users'],
        'license_key': value['license_key'],
        'license_type': value['license_type'],
        'license_is_active': value['license_is_active'],
        'license_valid_until': value['license_valid_until'] == null ? undefined : ((value['license_valid_until'] as any).toISOString()),
        'is_active': value['is_active'],
        'member_count': value['member_count'],
        'has_superadmin': value['has_superadmin'],
    };
}

